import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import * as smoothscroll from 'smoothscroll-polyfill';
import './index.scss';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { store, history } from './store';

if (process.env.NODE_ENV === 'development') {
    import('@axe-core/react').then((reactAxe) => {
        reactAxe.default(React, ReactDOM, 1000);
    });
}

const { SENTRY_DSN } = process.env.REACT_APP_MARKET_VALUES;

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: SENTRY_DSN,
        integrations: [new Integrations.BrowserTracing()],
        // per instructions from ingka sentry team in dt-sentry in slack
        tracesSampleRate: 0,
    });
}
// This is for smooth scrolling due to Safari compatibility
smoothscroll.polyfill();

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <Router history={history}>
                    <App />
                </Router>
            </ConnectedRouter>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
